import { render, staticRenderFns } from "./AccessLogsList.vue?vue&type=template&id=2a5aefbd&scoped=true&"
import script from "./AccessLogsList.vue?vue&type=script&lang=js&"
export * from "./AccessLogsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5aefbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a5aefbd')) {
      api.createRecord('2a5aefbd', component.options)
    } else {
      api.reload('2a5aefbd', component.options)
    }
    module.hot.accept("./AccessLogsList.vue?vue&type=template&id=2a5aefbd&scoped=true&", function () {
      api.rerender('2a5aefbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/auth/AccessLogsList.vue"
export default component.exports